import {useMutation} from "react-query";
import {deleteMoneyPoolCashout,deleteMoneyPoolCashin} from "services/fund";
import {toast} from "react-toastify";

interface IMoneyPoolCashin {
    moneypoolId:number,
    cashinId:number
}
interface IMoneyPoolCashout {
    moneypoolId:number,
    cashoutId:number
}

export function useDeleteMoneyPoolCashin() {
    const { isLoading, mutate } = useMutation({
        mutationFn: (moneyPoolCashin: IMoneyPoolCashin) => {
            return deleteMoneyPoolCashin(moneyPoolCashin)
        },
        onSuccess: (_, variables) => {
            toast.success('حذف تراکنش با موفقیت انجام شد.')
            window.location.reload()
        },
        onError: () => {
            toast.error('مشکلی در حذف تراکنش به وجود آمده!')
        },
    })
    return { isLoadingTransactionsAfterDeleteCashin:isLoading, mutateCashin:mutate }
}
export function useDeleteMoneyPoolCashout() {
    const { isLoading, mutate } = useMutation({
        mutationFn: (moneypoolCashout: IMoneyPoolCashout) => {
            return deleteMoneyPoolCashout(moneypoolCashout)
        },
        onSuccess: (_, variables) => {
            toast.success('حذف تراکنش با موفقیت انجام شد.')
            window.location.reload()
        },
        onError: () => {
            toast.error('مشکلی در حذف تراکنش به وجود آمده!')
        },
    })
    return { isLoadingTransactionsAfterDeleteCashout:isLoading, mutateCashout:mutate }
}

